import { Flex, FormItemsGroup, Spacing, Text } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoicingSettingsSection } from '../../../../../../enums/invoicingSettingsSection'
import { useTrackInvoicingSettingsDebounced } from '../../../../../../hooks/useTrackInvoicingSettingsDebounced'
import { BankTransferFields, PaymentMethodsTextField } from '../../../PaymentMethodsFields'
import * as Styled from './styles'

const section = InvoicingSettingsSection.PaymentsAndReminders

export const PaymentMethodsSettingsFields = (): ReactElement => {
  const { t } = useTranslation()
  const trackBankChange = useTrackInvoicingSettingsDebounced('Bank typed', { section })
  const trackIbanChange = useTrackInvoicingSettingsDebounced('IBAN typed', { section })
  const trackSwiftChange = useTrackInvoicingSettingsDebounced('SWIFT/BIC typed', { section })
  const trackPaypalEmailChange = useTrackInvoicingSettingsDebounced('Paypal e-mail typed', { section })
  const trackOfflinePaymentChange = useTrackInvoicingSettingsDebounced('Offline payment typed', { section })

  return (
    <Flex flexDirection="column" gap={Spacing.S24}>
      <Flex flexDirection="column" gap={Spacing.S8}>
        <Text weight="medium">{t('settings.organization.external_invoice.payment_methods.bank_transfer.title')}</Text>
        <Styled.BankTransferFieldsWrapper>
          <FormItemsGroup rowSpacing={Spacing.S16}>
            <BankTransferFields
              fields={{
                bank: {
                  label: t('settings.organization.external_invoice.payment_methods.bank_transfer.default_bank.label'),
                  onValueChange: trackBankChange,
                },
                iban: {
                  label: t('settings.organization.external_invoice.payment_methods.bank_transfer.default_iban.label'),
                  onValueChange: trackIbanChange,
                },
                swift: {
                  label: t('settings.organization.external_invoice.payment_methods.bank_transfer.default_swift.label'),
                  onValueChange: trackSwiftChange,
                },
              }}
            />
          </FormItemsGroup>
        </Styled.BankTransferFieldsWrapper>
      </Flex>
      <PaymentMethodsTextField
        fieldKey="paypalEmail"
        label={t('settings.organization.external_invoice.payment_methods.paypal.title')}
        onValueChange={trackPaypalEmailChange}
        placeholder={t('invoicing_settings.payments_and_reminders.paypal_placeholder')}
      />
      <PaymentMethodsTextField
        fieldKey="offlinePayment"
        label={t('settings.organization.external_invoice.payment_methods.offline_payment.title')}
        onValueChange={trackOfflinePaymentChange}
        placeholder={t('invoicing_settings.payments_and_reminders.offline_payment_placeholder')}
      />
    </Flex>
  )
}
